import React from 'react';
import './SiriusAwardsModal.scss';
import { useTranslation } from 'react-i18next';

const BACKGROUND_URL = '/assets/img/sirius_award_background.png';
const LOGO_URL = '/assets/img/sirius_award_logo.svg';

interface SiriusAwardsModalProps {
  onDiscoverMore: () => void;
  onClose: () => void;
}

export const SiriusAwardsModal: React.FC<SiriusAwardsModalProps> = ({ onDiscoverMore, onClose }) => {

    const { t } = useTranslation();

    return (
    <div className="sirius-modal-container">
      <button 
        className="sirius-close-button"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>

      <div 
        className="sirius-background"
        style={{ backgroundImage: `url(${BACKGROUND_URL})` }}
      />
      <div className="sirius-content">
        <div className="sirius-logo-wrapper">
          <img 
            src={LOGO_URL} 
            alt="LQA Sirius Awards Logo" 
            className="sirius-logo"
          />
        </div>
        <h1 className="sirius-heading">
          {t('common.LQA_SIRIUS_AWARDS.HEADING_INTRO')}<br />
          {t('common.LQA_SIRIUS_AWARDS.HEADING_TITLE')}
        </h1>
        <p className="sirius-description">
          {t('common.LQA_SIRIUS_AWARDS.DESCRIPTION_LINE1')}<br />
          {t('common.LQA_SIRIUS_AWARDS.DESCRIPTION_LINE2')}<br />
        </p>
        <p className="sirius-description-2">
          {t('common.LQA_SIRIUS_AWARDS.DESCRIPTION_LINE3')}<br />
          {t('common.LQA_SIRIUS_AWARDS.DESCRIPTION_LINE4')}
        </p>
        <button 
          className="sirius-button"
          onClick={onDiscoverMore}
        >
          {t('common.LQA_SIRIUS_AWARDS.DISCOVER_MORE')}
        </button>
      </div>
    </div>
  );
};

export default SiriusAwardsModal;
